// プロフィールに地域が未登録の利用者に、登録をお願いする枠（TodayTab の最上部に表示）
import React from 'react';
import { geocodePlace, placeFromDevice } from '../lib/userLocation';

export default function RegionPrompt({ name, current, onSave }: {
  name?: string;
  current?: string; // 登録済みだが場所を特定できなかった地名
  onSave: (location: string) => Promise<void> | void;
}) {
  const [value, setValue] = React.useState(current || '');
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState('');

  async function fromDevice() {
    setBusy(true); setErr('');
    const p = await placeFromDevice();
    setBusy(false);
    if (p) setValue(p);
    else setErr('現在地を取得できませんでした。地域名を入力してください。');
  }

  async function save() {
    const v = value.trim();
    if (!v) { setErr('地域を入力してください。'); return; }
    setBusy(true); setErr('');
    const hit = await geocodePlace(v);
    if (!hit) { setBusy(false); setErr('地域が見つかりませんでした。「東京都新宿区」のように、都道府県と市区町村で入力してください。'); return; }
    await onSave(v);
    setBusy(false);
  }

  return (
    <div style={{ background: 'linear-gradient(135deg,#fff7ed,#ffedd5)', border: '2px solid #f59e0b', borderRadius: '14px', padding: '14px', marginBottom: '16px' }}>
      <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#9a3412', marginBottom: '6px' }}>
        📍 {name ? `${name}さんの` : ''}お住まいの地域を登録してください
      </div>
      <div style={{ fontSize: '13px', color: '#7c2d12', lineHeight: 1.7, marginBottom: '10px' }}>
        {current
          ? `登録されている地域「${current}」の場所を特定できませんでした。都道府県と市区町村で登録し直してください。`
          : '天気・日の出と日の入り・近くのパワースポットなどを、お住まいの地域に合わせてお届けするために使います。'}
      </div>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        <input
          value={value}
          onChange={(e) => { setValue(e.target.value); setErr(''); }}
          placeholder="例：東京都新宿区、大阪府、北海道など"
          style={{ flex: '1 1 200px', minWidth: 0, padding: '10px 12px', borderRadius: '10px', border: '1px solid #fdba74', fontSize: '15px' }}
        />
        <button type="button" onClick={fromDevice} disabled={busy}
          style={{ padding: '10px 12px', borderRadius: '10px', border: '1px solid #fdba74', background: 'white', color: '#9a3412', fontSize: '14px', cursor: 'pointer' }}>
          📍 現在地から入力
        </button>
        <button type="button" onClick={save} disabled={busy}
          style={{ padding: '10px 16px', borderRadius: '10px', border: 'none', background: busy ? '#fdba74' : '#ea580c', color: 'white', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }}>
          {busy ? '確認中…' : '登録する'}
        </button>
      </div>
      {err && <div style={{ fontSize: '13px', color: '#b91c1c', marginTop: '8px' }}>{err}</div>}
    </div>
  );
}
